import React, { useState, useRef } from "react";
import { getPlatform } from "../utils";
import {PointUtil}from '../utils/point/PointUtil'

interface DownloadProps {
  downloadUrl: string; // 文件下载链接
  fileName: string; // 下载文件名
}

const DownloadComponent: React.FC<DownloadProps> = ({
  downloadUrl = "",
  fileName = "",
}) => {
  const platform = getPlatform();
  const linkRef = useRef<HTMLAnchorElement>(null);
  const [btnText, setBtnText] = useState<string>(`${platform === "iOS" ? "立即下载" : "下载"}`);


  const handleDownload = () => {
    PointUtil.pointEvent('click', '10.9.9.6')
    setBtnText(`下载中，请到${platform === "iOS" ? "App Store" : "下载栏"}查看进度`);
    if (linkRef.current) {
      linkRef.current.href = downloadUrl;
      linkRef.current.download = fileName;
      linkRef.current.click();
    }
    setTimeout(() => {
      setBtnText(`${platform === "iOS" ? "立即下载" : "下载"}`);
    }, 10 * 1000);
  };

  return (
    <div className="btn" style={btnText==='下载'? {}: {backgroundColor: 'linear-gradient(180deg, #2D303A 2%, #0C0D11 100%)'}} onClick={handleDownload}>
      <a ref={linkRef} style={{ display: "none" }}></a>
      {btnText}
    </div>
  );
};

export default DownloadComponent;
